import styled from 'styled-components/macro';
import pdf from '../../assets/icons/pdf-file.svg';

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
`;

export const SpeakerName = styled.div`
  width: fit-content;
  font-size: 16px;
  line-height: 16px;
  font-weight: 400;
  color: #3b81f4;
  margin-bottom: 8px;
`;

export const PdfIcon = styled.img.attrs({
  src: pdf,
})`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;
